export async function api(path, options = {}) {
  const response = await fetch(`/api${path}`, {
    credentials: "same-origin",
    ...options,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Trader-Request": "1",
      ...options.headers,
    },
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  });
  const data = await response.json();
  if (!response.ok) {
    const error=new Error(data.error||"Falha na solicitação.");error.status=response.status;
    if(response.status===401&&!path.startsWith('/auth/'))dispatchEvent(new Event('trader:unauthorized'));
    throw error;
  }
  return data;
}
export const post = (path, body = {}) => api(path, { method: "POST", body });
